import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth.guard';
import { roleGuardLoad } from './core/guards/role/role.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/home/routes'),
        canActivate: [authGuard],
    },
    {
        path: 'absences',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/absences/routes'),
        canMatch: [authGuard],
    },
    {
        path: 'stats',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/stats/routes'),
        canMatch: [authGuard],
    },
    {
        path: 'members',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/members/routes'),
        canMatch: [authGuard, roleGuardLoad],
        data: {
            roles: ['Comité'],
        },
    },
    {
        path: 'stats-general',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/stats/general-routes'),
        canMatch: [authGuard],
    },
    {
        path: 'appointments',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/appointments/routes'),
        canMatch: [authGuard],
    },
    {
        path: 'settings/change-password',
        loadComponent: () =>
            import('./layout/auth-layout/auth-layout.component').then(
                (m) => m.AuthLayoutComponent,
            ),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./features/settings/password-form.component').then(
                        (m) => m.PasswordFormComponent,
                    ),
            },
        ],
        canActivate: [authGuard],
    },
    {
        path: 'settings',
        loadComponent: () =>
            import('./layout/main-layout/main-layout.component').then(
                (m) => m.MainLayoutComponent,
            ),
        loadChildren: () => import('./features/settings/routes'),
        canMatch: [authGuard],
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./layout/auth-layout/auth-layout.component').then(
                (m) => m.AuthLayoutComponent,
            ),
        loadChildren: () => import('./features/auth/routes'),
    },
    {
        path: '**',
        redirectTo: '',
    },
];
